import { render, staticRenderFns } from "./NameForm.vue?vue&type=template&id=c92b4568&scoped=true&"
import script from "./NameForm.vue?vue&type=script&lang=js&"
export * from "./NameForm.vue?vue&type=script&lang=js&"
import style0 from "./NameForm.vue?vue&type=style&index=0&id=c92b4568&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c92b4568",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VForm,VIcon,VTextField,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c92b4568')) {
      api.createRecord('c92b4568', component.options)
    } else {
      api.reload('c92b4568', component.options)
    }
    module.hot.accept("./NameForm.vue?vue&type=template&id=c92b4568&scoped=true&", function () {
      api.rerender('c92b4568', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/pages/Paper/components/NameForm.vue"
export default component.exports